import { dscvrIcApi } from '@/shared/api';

export const useActiveWindowQuery = () => {
  return dscvrIcApi.streak.getActiveWindow();
};
